import { forwardRef } from 'react';
import { ReactKit } from '@team/react';
import { Caption } from '../../../../typography/caption';
import { OptionProps } from '../../types';
import { VisuallyHidden } from '../../../../services/visually-hidden';
import { Tappable } from '../../../../services/tappable';
import css from './style.module.css';

export const Radio = forwardRef<HTMLLabelElement, OptionProps>(
  function Component(
    {
      className,
      style,
      children,
      inputRef,
      checked = false,
      indicator,
      ...inputProps
    },
    forwardedRef
  ) {
    const hasIndicator = ReactKit.hasNode(indicator);

    return (
      <Tappable
        Component="label"
        hoverMode="opacity"
        activeMode="none"
        baseClassName={css.root}
        className={className}
        style={style}
        aria-selected={checked}
        ref={forwardedRef}
      >
        <VisuallyHidden
          {...inputProps}
          Component="input"
          type="radio"
          checked={checked}
          ref={inputRef}
        />

        <div className={css.inner}>
          {hasIndicator && <div className={css.corner} />}

          <Caption className={css.label} level={1} weight={checked ? 2 : 3}>
            {children}
          </Caption>

          {hasIndicator && <div className={css.corner}>{indicator}</div>}
        </div>
      </Tappable>
    );
  }
);
